import { render, staticRenderFns } from "./wowKitDashboard.vue?vue&type=template&id=d59a6a16"
import script from "./wowKitDashboard.vue?vue&type=script&lang=js"
export * from "./wowKitDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports